import moment from 'moment';

import {
  getSessionStartDateTime,
  isClientAssignmentActiveAtDateTime,
} from '../../utils/clientCohortAssignments';

import type { Moment } from 'moment';
import type { Bays, IClientAssignment } from '../../../../utils/types';

export function getBayActiveAtDateTime(
  assignments: IClientAssignment[],
  dateStart: Moment | null,
): Bays | undefined {
  const start = dateStart ? moment(dateStart) : null;
  if (!start) return undefined;
  const sessionDateTime = getSessionStartDateTime(start, start);
  const names = assignments
    .filter((assignment) => isClientAssignmentActiveAtDateTime(assignment, sessionDateTime))
    .map((assignment) => assignment.cohort?.name)
    .filter((name): name is Bays => Boolean(name));

  return names[0];
}
